export const SET_ONLY_OFFICE_URL = 'setOnlyOfficeUrl';
export const CLEAR_ONLY_OFFICE_REDUX_STORE = 'clearOnlyOfficeReduxStore';
